import { useEffect, useState } from "react";

export function useDelayedState<T>(
    state: T,
    checkOpen: (state: T) => boolean,
    timeoutMilliSecond: number
): { delayedState: T; delayedOpen: boolean } {
    const [delayedState, setDelayedState] = useState(state);
    useEffect(() => {
        if (checkOpen(state)) {
            // When it opens
            setDelayedState(state);
            return;
        }

        // When it closes
        const timeoutId = setTimeout(() => {
            setDelayedState(state);
        }, timeoutMilliSecond);
        return () => {
            clearTimeout(timeoutId);
        };
    }, [state, timeoutMilliSecond, checkOpen]);

    return { delayedState, delayedOpen: checkOpen(delayedState) };
}
